import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

const Affiliates = () => {

  const toast = useRef(null)
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [affiliateData, setAffiliateData] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
      getAffiliates()
  }, [])
  
  const getAffiliates = async () => {
    await ApiHelper.get(API_ENDPOINTS.AFFILIATES).then((res) => {
      // console.log('res: ', res);
      if (res.status === 200) {
        setAffiliateData(res.data.data)
        }
    }).catch((error) => {
        console.log("Error: ", error);
    })
  }

  const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <button onClick={() => navigate(`/affiliates/view/${rowData.affiliateId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-view-list"></i> </button>
        <button onClick={() => navigate(`/affiliates/edit/${rowData.affiliateId}`)} className="btn btn-primary btn-sm"> <i class="bi bi-pencil-square"></i> </button>
        <button onClick={() => confirmDeleteDailog(rowData.affiliateId)} className="btn btn-danger btn-sm mx-2"> <i class="bi bi-trash"></i> </button>
      </>
    );
  };

  const confirmDeleteDailog = (id) => {
    confirmDialog({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      defaultFocus: null,
      acceptClassName: 'p-button-danger',
      accept: () => deleteAffiliate(id),
    });
  };

  const deleteAffiliate = (id) => {
    ApiHelper.delete(`${API_ENDPOINTS.AFFILIATES}/${id}`).then((res) => {
      if (res.status === 200) {
        toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
        getAffiliates()
      }
    }).catch((error) => {
        console.log("Error: ", error);
    })
  }

  const ordersBodyTemplate = (rowData) => {
    return (
      <>
        <div className='d-flex gap-1 align-items-center'>
          <span className='badge text-bg-light m-0' style={{cursor:  rowData.affiliateOrderCount !== '0' && 'pointer'}} onClick={() => {rowData.affiliateOrderCount !== '0' && navigate(`/affiliates/orders/${rowData.affiliateId}`)}}>{rowData.affiliateOrderCount}</span>
        </div>
      </>
    );
  };

  const nameBodyTemplate = (rowData) => {
    return (
      <>
        <div style={{ alignItems: "center", gap: "10px", cursor: 'pointer', color: 'blue' }} onClick={() => navigate(`/affiliates/edit/${rowData.affiliateId}`)}>
          <div>
            <span>{rowData?.fullName}</span>
          </div>
          <div>
            <small>{rowData?.mobileNumber}</small>
          </div>
          <div>
            <small>{rowData?.email}</small>
          </div>
        </div>
      </>
    );
  };

  const isActiveBodyTemplate = (rowData) => {
    return (
      <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'}`}>
          {rowData.isActive ? 'Active' : 'Inactive'}
      </span>
    );
  };
  
  const statusBodyTemplate = (rowData) => {
    return (
      <span className={`badge ${(rowData.status === 'approved' && 'bg-success') || (rowData.status === 'pending' && 'bg-warning') || (rowData.status === 'rejected' && 'bg-danger')}`}>
          {rowData.status}
      </span>
    );
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
        </IconField>
      </div>
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Layout>
        <div class="content-wrapper">
          <div class="container-xxl flex-grow-1 container-p-y">
            <div class="d-flex justify-content-between align-items-center py-3">
                <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page"> Affiliates </p> </span></h4>
                <Link class="btn btn-primary" to={'/affiliates/add'} >Add New Affiliate</Link>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card mb-4">
                  <div class="card-body">
                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={affiliateData} tableStyle={{ minWidth: '50rem' }} >
                      <Column body={serialNoTemplate} header='S.NO' />
                      <Column sortable header='Name' body={nameBodyTemplate} field='fullName' /> 
                      <Column sortable header='Orders' body={ordersBodyTemplate} field='affiliateOrderCount' />
                      <Column sortable header='Sales' field='totalAffiliateSales' />
                      <Column sortable header='Commission' field='commissionAmount' />
                      <Column sortable header='Code' field='affiliateCode' />
                      <Column sortable header='Status' body={statusBodyTemplate} field='status' />
                      <Column sortable header='Active' body={isActiveBodyTemplate} field='isActive' />
                      <Column sortable header='Action' body={actionBodyTemplate} />
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout> 
    </>
  )
}

export default Affiliates
